import {ChevronDownIcon} from '@chakra-ui/icons';
import {
  Button,
  ButtonProps,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import React, {ReactNode} from 'react';
import {FILTER_BUTTON_PROPS} from './FilterBarStyles';

// Bouton déclencheur + popover partagés par les filtres multi-valeurs de la FilterBar desktop
// (Labels, Caractéristiques fromage, Température...). Applique le style commun FILTER_BUTTON_PROPS
// au trigger et encapsule le contenu du filtre dans un popover uniforme.

interface FilterBarPopoverFilterProps {
  label: string;
  isActive: boolean;
  isDisabled?: boolean;
  // Permet de surcharger le bouton trigger (ex: borderColor surgelé, leftIcon)
  buttonProps?: ButtonProps;
  contentMaxW?: string;
  bodyMaxH?: string;
  children: ReactNode;
}

export const FilterBarPopoverFilter: React.FC<FilterBarPopoverFilterProps> = ({
  label,
  isActive,
  isDisabled,
  buttonProps,
  contentMaxW = '400px',
  bodyMaxH = '300px',
  children,
}) => (
  <Popover placement='bottom-start'>
    <PopoverTrigger>
      <Button
        {...FILTER_BUTTON_PROPS}
        rightIcon={
          <ChevronDownIcon
            color='blue.main'
            fontWeight='bold'
            boxSize='23px'
          />
        }
        border='2px'
        fontSize='xs'
        fontWeight='500'
        borderColor={isActive ? 'gray.dark' : 'gray.light'}
        isDisabled={isDisabled}
        {...buttonProps}
      >
        {label}
      </Button>
    </PopoverTrigger>
    <PopoverContent
      width='auto'
      maxW={contentMaxW}
    >
      <PopoverBody
        maxH={bodyMaxH}
        overflowY='auto'
        backgroundColor='gray.75'
        p={4}
      >
        {children}
      </PopoverBody>
    </PopoverContent>
  </Popover>
);
